import React, { Component } from "react";
class RecordCanvas extends Component {



  startWave = () => {
    console.log("startWave")
    // console.log(this.props.control)
    if (this.props.control == true) {



      this.ctx = this.cnv.getContext("2d");

      let freqs;

      navigator.mediaDevices.enumerateDevices().then(devices => {
        devices.forEach((d, i) => console.log(d.label, i));
        navigator.mediaDevices
          .getUserMedia({
            audio: true,
            // video:true
          })
          .then(stream => {
            this.stream = stream;

            const context = new AudioContext()//(window.AudioContext || window.webkitAudioContext)();
            const analyser = context.createAnalyser();
            const source = context.createMediaStreamSource(stream);

            const biquadFilter = context.createBiquadFilter();
            biquadFilter.type = "highshelf";
            biquadFilter.frequency.setValueAtTime(1000, context.currentTime);//.value = 1000;
            biquadFilter.gain.setValueAtTime(10, context.currentTime)//value = range.value;


            source.connect(analyser);
            // analyser.connect(context.destination);


            freqs = new Uint8Array(analyser.frequencyBinCount);
            // setInterval(() => {
            //   console.log(freqs)
            // }, 10000)

            const draw = () => {
              let radius = 25;
              let bars = 500;

              // Draw Background
              // ctx.fillStyle = "white";
              if (this.ctx && this.cnv) {
                this.ctx.clearRect(0, 0, this.cnv.width, this.cnv.height);
                // ctx.fillRect(0, 0, myCanvas.width, myCanvas.height);

                // Draw circle
                this.ctx.beginPath();
                this.ctx.arc(
                  this.cnv.width / 2,
                  this.cnv.height / 2,
                  radius,
                  0,
                  2 * Math.PI
                );
                this.ctx.stroke();
                analyser.getByteFrequencyData(freqs);



                // // Draw label
                // this.ctx.font = "500 24px Helvetica Neue";
                // const avg =
                //   [...Array(255).keys()].reduce((acc, curr) => acc + freqs[curr], 0) /
                //   255;
                // this.ctx.fillStyle = "rgb(" + 200 + ", " + (200 - avg) + ", " + avg + ")";
                // this.ctx.textAlign = "center";
                // this.ctx.textBaseline = "top";
                // this.ctx.fillText("SPACE", this.cnv.width / 2, this.cnv.height / 2 - 24);
                // this.ctx.fillText("FORCE", this.cnv.width / 2, this.cnv.height / 2 + 6);


                for (var i = 0; i < bars; i++) {
                  let radians = (Math.PI * 10) / bars;
                  let bar_height = freqs[i] * 0.06;

                  let x = this.cnv.width / 2 + Math.cos(radians * i) * radius;
                  let y = this.cnv.height / 2 + Math.sin(radians * i) * radius;
                  let x_end =
                    this.cnv.width / 2 + Math.cos(radians * i) * (radius + bar_height);
                  let y_end =
                    this.cnv.height / 2 + Math.sin(radians * i) * (radius + bar_height);
                  let color = '#007aff20';
                  // "rgb(" + 149 + ", " + (149 - freqs[i]) + ", " + freqs[i] + ")";
                  this.ctx.strokeStyle = color;
                  this.ctx.lineWidth = 3;
                  this.ctx.beginPath();
                  this.ctx.moveTo(x, y);
                  this.ctx.lineTo(x_end, y_end);
                  this.ctx.stroke();


                }
                // // Draw bars
                // for (var i = 0; i < bars; i++) {
                //   let radians = (Math.PI * 2) / bars;

                //   let bar_height = freqs[3] * 0.2;

                //   let x = this.cnv.width / 2 + Math.cos(radians * i) * radius;
                //   let y = this.cnv.height / 2 + Math.sin(radians * i) * radius;
                //   let x_end =
                //     this.cnv.width / 2 + Math.cos(radians * i) * (radius + bar_height);
                //   let y_end =
                //     this.cnv.height / 2 + Math.sin(radians * i) * (radius + bar_height);
                //   let color =
                //     "#D8BFD8";
                //   this.ctx.strokeStyle = color;
                //   this.ctx.fillStyle = "#953553";
                //   var background = new Image();
                //   // background.src = "http://i.imgur.com/yf6d9SX.jpg";
                //   // background.onload = function () {
                //   this.ctx.drawImage(background, 0, 0);
                //   // }
                //   this.ctx.fill();
                //   this.ctx.lineWidth = 3;
                //   this.ctx.beginPath();
                //   this.ctx.moveTo(x, y);
                //   this.ctx.lineTo(x_end, y_end);
                //   this.ctx.stroke();

                // ctx.moveTo(10, 50);
                // ctx.lineTo(100, 50);
                // ctx.stroke();
              }

              requestAnimationFrame(draw);
            }

            requestAnimationFrame(draw);
          });
      });


    } else {
      // console.log("TP EXIT")

      if (this.stream !== undefined) {
        this.off = () => {//toggle state
          // console.log(this.stream)
          this.stream.getAudioTracks().forEach(function (track) {
            // track.enabled = false;
            track.stop()
            // console.log("app", track.enabled = false)
          });
          // this.stream.getTracks().find(track => track.kind === 'audio').enabled = false;
          // console.log(this.stream.getAudioTracks()[0])
          // console.log(navigator.mediaDevices)
        };
        this.off()
      }
    }


  }



  render() {
    return (
      <canvas id="myCanvas" ref={el => this.cnv = el} width="100" height="100" style={{ opacity: this.props.pauseRecord ? 0 : 1 }}></canvas>
    )
  }

}

export default RecordCanvas;